// @flow
import * as React from 'react';
import { Stack, Typography } from '@mui/material';
import { NextActionCard, NextActionFormButton, NoData } from '../../../../shared';
import { useClient } from '../../hooks/client-context';
import { useClientNextActions } from '../../hooks/use-client-next-actions';
import _ from 'lodash';
import { getUserName } from '@coverright/utils';
import { keycloak } from '@coverright/shared/keycloak';

export const ClientNextActions = () => {
  const client = useClient();
  const nextActions = useClientNextActions(client.id)
  return (
    <Stack gap={2} flex={1}>
      <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Typography variant={'subtitle1'} flex={1}>Next actions</Typography>
        <NextActionFormButton initialValues={{
          clientId: client.id,
          clientName: getUserName(client),
          assigneeAgentId: keycloak?.tokenParsed?.sub,
          done: false,
          title: ''
        }} />
      </Stack>

      {!nextActions.length && <NoData height={100} sx={{flex: 'initial'}}>No next actions</NoData>}
      {_.orderBy(nextActions, ['done', 'dueDate'], 'asc').map((action, index) => (
        <NextActionCard item={action} key={index} />
      ))}
    </Stack>
  );
};


